import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose } from 'recompose';
import TicketEntryForm from '../TicketEntryForm';
import { queryTicketNumberDetailsGQL } from '../graphql/getTicketNumberDetails';


const propTypes = exact({
  onComplete: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  ticketNumberData: PropTypes.object,
  ticketNumber: PropTypes.object.isRequired,
  date: PropTypes.string,

  /* eslint-disable react/no-unused-prop-types */
  ticketNumberId: PropTypes.number.isRequired,
  data: PropTypes.object,
/* eslint-enable react/no-unused-prop-types */
});


const TicketFormWrapper = (props) => {
  const { onComplete, selectedItem, loading, ticketNumberData, ticketNumber, date } = props;
  return (
    <div>
      <TicketEntryForm
        onComplete={onComplete}
        selectedItem={selectedItem}
        loading={loading}
        ticketNumberData={ticketNumberData}
        ticketNumber={ticketNumber}
        date={date}
      />
    </div>
  );
};

TicketFormWrapper.propTypes = propTypes;

const enhance = compose(queryTicketNumberDetailsGQL);

export default enhance(TicketFormWrapper);
